import React from "react";
import Modal from "react-modal";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const paymentUrl = `${process.env.REACT_APP_PAYMENT_SERVER_URL}/payment`;

Modal.setAppElement("#root");

function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

const ContentLockPopup = ({ isOpen, closePopup, price, handleSuccess }) => {
  const [disable, setDisable] = useState(false);

  const user = useSelector((state) => state.user.data);

  const navigate = useNavigate();

  const displayRazorpay = async () => {
    setDisable(true);

    try {
      const res = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );

      if (!res) {
        alert("Razorpay SDK failed to load. Are you online?");
        return;
      }

      // creating a new order

      const result = (
        await axios.post(`${paymentUrl}/orders`, {
          amount: price,
        })
      ).data;

      if (!result && !result.data) {
        alert("Server error. Are you online?");
        return;
      }

      // Getting the order details back
      const { amount, id: order_id, currency } = result.data.order;

      const options = {
        key: "rzp_live_aYc0rrOMtTd7jO", // Enter the Key ID generated from the Dashboard rzp_test_LlskR8yTRblmZg
        amount: amount.toString(),
        currency: currency,
        name: user.username,
        // description: "Test Transaction",
        // image: { logo },
        order_id,
        handler: async function (response) {
          const data = {
            orderCreationId: order_id,
            razorpayPaymentId: response.razorpay_payment_id,
            razorpayOrderId: response.razorpay_order_id,
            razorpaySignature: response.razorpay_signature,
          };

          const res = await axios.post(`${paymentUrl}/verify-payment`, data);

          if (res.data.success) {
            // closePopup();
            handleSuccess();
          } else {
            alert(res.data.message);
          }
        },
        prefill: {
          name: user.displayName,
          email: user.email,
        },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (err) {
      alert(err.message || "something went wrong!");
    } finally {
      setDisable(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      style={{
        overlay: {
          background: "rgba(256,256,256,1)",
          zIndex:100,
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          maxWidth: '90%',
          width: '24rem',
          padding: '1rem',
        },
      }}
    >
      <h2 className="text-md font-semibold mb-1 capitalize">Time is running out your not become younger</h2>
      <p className="text-sm mb-2 text-gray-700 font-semibold">
      Your Mirror is Your Worst Enemy
      -Because It Shows the Truth Your Excuses Are Written AII
      Over Your Body Time is a Silent Killer-And
      You're Letting It Destroy You. Buy it now!
      </p>
      <div className="flex items-center justify-between gap-4 h-10 my-2">
        <button
          className={`w-full h-full text-center hover:bg-red-400 rounded-xl ${
            disable ? "bg-gray-600 text-gray-800 hover:bg-gray-500" : "bg-red-500 text-white"
          } text-md font-semibold text-sm`}
          onClick={displayRazorpay}
          disabled={disable}
        >
          {disable ? "Please wait..." : "Subscribe"}
        </button>
        <button
          className="w-full h-full text-center hover:bg-gray-200 rounded-xl border border-red-500 text-md font-semibold text-sm"
          onClick={() => navigate(-1)}
        >
          Go back!
        </button>
      </div>
    </Modal>
  );
};

export default ContentLockPopup;
